export default __webpack_public_path__ + "static/media/slide21.2b822b51.jpg";